import {
  TOGGLE_USER_ROLES_FAILURE,
  TOGGLE_USER_ROLES_START,
  TOGGLE_USER_ROLES_SUCCESS,
} from 'constants/action-types/user/toggleUserRoles';

export default (state, { type, payload }) => {
  switch (type) {
    case TOGGLE_USER_ROLES_START:
      return {
        ...state,
        toggleUserRoles: {
          loading: true,
          error: null,
          message: null,
        },
      };
    case TOGGLE_USER_ROLES_FAILURE:
      return {
        ...state,
        toggleUserRoles: {
          ...state.toggleUserRoles,
          loading: false,
          error: payload,
        },
      };
    case TOGGLE_USER_ROLES_SUCCESS:
      return {
        ...state,
        toggleUserRoles: {
          ...state.toggleUserRoles,
          loading: false,
          message: payload,
        },
      };
    default:
      return null;
  }
};
